import { LocalVideoTrack } from 'livekit-client';
import { action, observable, makeAutoObservable } from 'mobx';

class LocalTracksStore {
    @observable public localVideoTrack: LocalVideoTrack | null = null;

    public constructor() {
        makeAutoObservable(this);
    }

    @action
    public setLocalVideoTrack = (localVideoTrack: LocalVideoTrack | null) => {
        this.localVideoTrack = localVideoTrack;
    };
}

export const localTracksStore = new LocalTracksStore();
